<template>
  <el-container class="main-container">
    <!-- <SidebarMenu /> -->
    <el-container>
      <el-header class="header">
        <h2
          class="title"
          @click="toggleSkip"
        >{{ $t('MainContent.startCodeScan') }}</h2>
        <el-steps
          class="steps"
          v-if="hasAccess"
          :active="stepIndex"
          :space="200"
          :align-center="true"
          finish-status="success"
        >
          <el-step
            v-for="step in stepList"
            :key="step.label"
            :title="$t(`MainContent.${step.label}`)"
          ></el-step>
        </el-steps>
        <p v-else>{{ $t('MainContent.freeVulnerabilityScan') }}</p>
      </el-header>
      <el-main class="main">
        <div
          class="alertContent"
          v-if="isDraft"
        >
          <el-alert
            class="draftAlert"
            type="warning"
            show-icon
            close-text=" "
            center
          >
            <div slot="title">
              <span>
                {{ $t('MainContent.draftDataReserve') }}
              </span>
              <el-button
                style="margin: 0 10px"
                size="mini"
                type="warning"
                plain
                @click="handleCloseAlert"
              >{{ $t('MainContent.reserve') }}({{countdownTime}}s)</el-button>
              <el-button
                style="margin: 0"
                size="mini"
                type="info"
                plain
                @click="handleDiscardDraft"
              >{{ $t('MainContent.discard') }}</el-button>
            </div>
          </el-alert>
        </div>
        <div
          class="alertContent"
          v-if="isOutOfToken && hasAccess && !isSaas"
        >
          <el-alert
            type="warning"
            show-icon
            :closable="false"
          >
            <div slot="title">当前可用额度：{{ availableTokens }} 个令牌，无法继续创建评估任务，请及时购买。<el-link
                style="color: #409EFF;margin-top: -2px;text-decoration: underline;"
                :underline="false"
                @click="handleBuyToken"
              >增加额度</el-link></div>
          </el-alert>
        </div>
        <div class="content">
          <component
            ref="current"
            :payload="payload"
            :is="stage"
            @next="handleNext"
            @next-loading="toggleNextLoading"
            @next-disabled="toggleNextDisabled"
          />
        </div>
      </el-main>
      <el-footer class="footer">
        <div
          class="checkService"
          v-if="stage === 'TaskPreview' && isSaas"
        >
          <el-checkbox
            class="checkboxService"
            size="medium"
            v-model="checkService"
          ></el-checkbox>
          <div class="checkServiceText">
            <i18n
              path="MainContent.termsOfService"
              :places="{APP_TITLE: APP_TITLE}"
            >
              <span
                class="serviceItem"
                @click="handleTermOfService"
              >{{$t('MainContent.termServiceLink')}}</span>
              <span
                class="serviceItem"
                @click="handlePrivacyPolicy"
              >{{$t('MainContent.privacyPolicy')}}</span>
            </i18n>
          </div>
        </div>
        <div class="footerBtn">
          <el-button
            v-if="showPrevBtn"
            type="primary"
            size="large"
            class="primaryButton nextButton"
            @click="handlePrev"
          >{{ $t('MainContent.previous') }}</el-button>
          <div
            class="scanBtnWrapper"
            v-if="stage === 'TaskPreview'"
          >
            <el-button
              style="margin-left: 20px;"
              :disabled="scanDisabled"
              type="primary"
              size="large"
              class="nextButton"
              :loading="scanLoading"
              @click="handleSubmit"
            >{{ $t('MainContent.scan') }}</el-button>
          </div>
          <el-button
            v-else
            type="primary"
            size="large"
            class="primaryButton nextButton"
            :disabled="nextDisabled || isOutOfToken"
            :loading="nextLoading"
            @click="handleNext"
          >{{ $t('MainContent.next') }}</el-button>
          <el-button
            v-if="stage === 'LoginUrlBrowser'"
            type="default"
            size="large"
            class="primaryButton nextButton"
            @click="handleLoginUrlBrowserSkip"
          >{{ $t('MainContent.skipLogin') }}</el-button>
          <el-button
            v-if="devMode"
            type="primary"
            size="large"
            class="primaryButton nextButton"
            @click="handleSkip"
          >{{ $t('MainContent.skip') }}</el-button>
        </div>
      </el-footer>
    </el-container>
    <el-dialog
      width="300px"
      :visible.sync="showRequestAccess"
      @close="showRequestAccess = false"
      :show-close="false"
    >
      <div class="accessDialog">
        <div class="accessDialogTitle">{{  applyInfo ? $t('MainContent.waitingForApproval') : $t('MainContent.accountNotActivated') }}</div>
        <el-button
          type="primary"
          style="background: black;border: none;"
          @click="requestAccess"
        >
          {{  applyInfo ? $t('MainContent.modifyApplication') : $t('MainContent.requestAccess') }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogType === 'termsOfService' ? $t('MainContent.termServiceLink') : $t('MainContent.privacyPolicy')"
      width="50%"
      :center="true"
      :visible.sync="termOfServiceShow"
      @close="termOfServiceShow = false"
      :show-close="false"
      custom-class="termOfServiceDialog"
      destroy-on-close
    >
      <div class="termOfService">
        <div class="termOfServiceContent">
          <mark-down
            :content="markdownContent"
            :products="products"
          ></mark-down>
        </div>
        <div class="termOfServiceBtn">
          <el-button
            size="small"
            style="margin-right: 10px;"
            @click="termOfServiceShow = false"
          >{{$t('MainContent.close')}}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="checkService = true; termOfServiceShow = false"
          >{{$t('MainContent.agree')}}</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="额度不足"
      width="30%"
      center
      :visible.sync="showAvailableTokens"
    >
      <p>当前可用额度不足（{{ availableTokens }}个令牌），请联系技术支持增加使用额度。</p>
      <div slot="footer">
        <el-button
          type="primary"
          @click="showAvailableTokens = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import TargetService from './components/target-service.vue';
import TextFileUrl from './components/text-file-url.vue';
import ProjectCode from './components/project-code.vue';
import OptionalCode from './components/optional-code.vue';
import ServiceUrl from './components/service-url.vue';
import TestAccount from './components/test-account.vue';
import TaskPreview from './components/task-preview.vue';
import LoginUrl from './components/login-url.vue';
import LoginUrlBrowser from './components/login-url-browser.vue';
import TestAccountConfirm from './components/test-account-confirm.vue';
import MarkDown from '@/components/mark-down';

import { mapGetters, mapActions } from 'vuex';

import { getSourceIp, createTask, getApplyInfo } from '@/api/base';
import { storage } from '@/utils/storage';
import EventBus, { EventType } from '@/lib/events';
import { ScanDataKey, LANGUAGE_TYPES, RemoteBrowserUrlKey } from '@/enum';

import termsOfService from '@docs/docs/terms-of-service.md';
import privacyPolicy from '@docs/docs/privacy-policy.md';

const expiration = 1000 * 60 * 60 * 24; // 24 hours
const getDefaultScanData = () => ({
  lang: LANGUAGE_TYPES.JAVA,
  projectName: '',
  sandboxHomePageUrl: '',
  sandboxTargetServiceUrl: '',
  javaPackage: '',
  javaPackageName: '',
  sourceCodeInfos: [],
  testAccounts: [],
});

const StepStageMap = [
  {
    label: 'javaArchive',
    stage: ['ProjectCode'],
    type: 'all',
    relatedData: [
      {
        stage: 'ProjectCode',
        key: 'projectName',
        defaultValue: '',
      },
      {
        stage: 'ProjectCode',
        key: 'javaPackage',
        defaultValue: '',
      },
      {
        stage: 'ProjectCode',
        key: 'javaPackageName',
        defaultValue: '',
      },
    ],
  },
  {
    label: 'connectivityCheck',
    stage: ['TargetService'],
    type: 'all',
    relatedData: [
      {
        stage: 'TargetService',
        key: 'sandboxTargetServiceUrl',
        defaultValue: '',
      },
    ],
  },
  {
    label: 'ownershipVerification',
    stage: ['TextFileUrl'],
    type: 'saas',
  },
  {
    label: 'sourceCodeOptional',
    stage: ['OptionalCode'],
    type: 'saas',
    relatedData: [
      {
        stage: 'OptionalCode',
        key: 'sourceCodeInfos',
        defaultValue: [],
      },
    ],
  },
  {
    label: 'testAccount',
    stage: ['LoginUrlBrowser'],
    type: 'all',
    relatedData: [
      {
        stage: 'LoginUrlBrowser',
        key: 'testAccounts',
        defaultValue: [],
      },
    ],
  },
  {
    label: 'preview',
    type: 'all',
    stage: ['TaskPreview'],
  },
];

export default {
  name: 'MainContentComponent',
  components: {
    TargetService,
    TextFileUrl,
    ProjectCode,
    OptionalCode,
    ServiceUrl,
    TestAccount,
    TextFileUrl2: TextFileUrl,
    TaskPreview,
    LoginUrl,
    LoginUrlBrowser,
    MarkDown,
    TestAccountConfirm,
  },
  provide() {
    return {
      sourceIp: this.sourceIp,
      taskData: this.taskData,
      loginInfos: this.loginInfos,
    };
  },
  data() {
    const scanData = storage.get(ScanDataKey);
    const { data, stage, skipAccount } = scanData || {};

    return {
      termOfServiceShow: false,
      nextDisabled: false,
      nextLoading: false,
      isDraft: Boolean(scanData),
      scanLoading: false,
      checkService: false,
      skip: 0,
      showRequestAccess: false,
      // devMode: process.env.NODE_ENV === 'development',
      stage: stage || StepStageMap[0].stage[0],
      skipAccount: skipAccount || false,
      sourceIp: {
        ipv4: '',
        ipv6: '',
      },
      taskData: {
        ...getDefaultScanData(),
        ...data,
      },
      countdownTime: 10,
      dialogType: 'termsOfService',
      loginInfoIndex: 0,
      loginInfos: [
        {
          loginUrl: data?.sandboxHomePageUrl || '',
          testAccounts: [],
        },
      ],
      stageList: [],
      showAvailableTokens: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasAccess', 'isAuthenticated', 'applyInfo', 'isAdmin', 'availableTokens']),
    ...mapGetters('common', ['isSaas']),
    devMode() {
      const devModeProjectNameReg = /^zast-dev-.*$/;
      const isDevMode = devModeProjectNameReg.test(this.taskData.projectName);

      return this.isAuthenticated && this.hasAccess && isDevMode && this.stage === 'TextFileUrl' && this.isAdmin;
    },
    payload() {
      const stage = this.stage;

      switch (stage) {
        case 'TargetService':
          return {
            url: this.taskData.sandboxTargetServiceUrl,
          };
        case 'TextFileUrl':
          return {
            url: this.taskData.sandboxTargetServiceUrl,
          };
        case 'TextFileUrl2':
          return {
            url: this.taskData.sandboxTargetServiceUrl,
            stageName: 'TextFileUrl2',
          };
        case 'OptionalCode':
          return {
            sourceCodeInfos: this.taskData.sourceCodeInfos,
          };
        case 'LoginUrl':
          return {
            serviceUrl: this.taskData.sandboxTargetServiceUrl,
            sandboxHomePageUrl: this.loginInfos[this.loginInfoIndex]?.loginUrl || '',
            skipAccount: this.skipAccount || false,
            restLoginUrlList: this.loginInfos.filter((_, index) => index !== this.loginInfoIndex).map((item) => item.loginUrl),
          };
        case 'LoginUrlBrowser':
          return {
            serviceUrl: this.taskData.sandboxTargetServiceUrl,
          };
        case 'TestAccount':
          return {
            accountList: this.loginInfos[this.loginInfoIndex]?.testAccounts || [],
            loginUrl: this.loginInfos[this.loginInfoIndex]?.loginUrl || '',
          };
        case 'TestAccountConfirm':
          return {
            loginInfos: this.loginInfos,
          };
        case 'ProjectCode':
          return {
            projectName: this.taskData.projectName,
            fileSha: this.taskData.javaPackage,
            fileName: this.taskData.javaPackageName,
            lang: this.taskData.lang,
          };
        case 'TaskPreview':
          return {
            testAccounts: this.taskData.testAccounts,
          };
        default:
          return {};
      }
    },
    scanDisabled() {
      if (this.stage === 'TaskPreview' && !this.checkService) {
        return true;
      }

      return false;
    },
    stepIndex() {
      return StepStageMap.findIndex((item) => item.stage.includes(this.stage));
    },
    stepList() {
      const stepList = StepStageMap.filter((item) => item.label !== 'preview');

      if (this.isSaas) {
        return stepList.filter((item) => item.type === 'saas' || item.type === 'all');
      }

      return stepList.filter((item) => item.type === 'all');
    },
    showPrevBtn() {
      const prevStag = this.getPrevStage(this.stage);

      return prevStag !== null;
    },
    products() {
      return {
        APP_TITLE: this.APP_TITLE,
        EXTENSION_NAME: this.EXTENSION_NAME,
        SUPPORT_EMAIL: this.SUPPORT_EMAIL,
        DISCORD_URL: this.DISCORD_URL,
        HOME_URL: this.HOME_URL,
        BLOG_URL: this.BLOG_URL,
      };
    },
    markdownContent() {
      if (this.dialogType === 'termsOfService') {
        return termsOfService;
      }

      return privacyPolicy;
    },
    isOutOfToken() {
      return Number(this.availableTokens) <= 0;
    },
  },
  watch: {
    hasAccess: {
      immediate: true,
      handler(newValue) {
        if (!newValue && this.isAuthenticated) {
          this.getApplyInfo();
        }
      },
    },
    isSaas: {
      immediate: true,
      handler(newValue) {
        this.checkService = newValue ? false : true;
      },
    },
  },
  mounted() {
    if (this.hasAccess) {
      this.getSourceIp();
    }

    if (this.isDraft) {
      this.countdown();
    }

    EventBus.$on('noAccess', () => {
      this.showRequestAccess = true;
    });
    EventBus.$emit(EventType.Extension, { action: 'reset' });
    EventBus.$emit(EventType.Extension, { action: 'checkIncognito' });
  },
  methods: {
    ...mapActions('user', ['setApplyInfo']),
    getApplyInfo() {
      getApplyInfo().then((res) => {
        this.setApplyInfo(res);
      });
    },
    handleBuyToken() {
      this.$router.push({ name: 'TokenManage' });
    },
    toggleSkip() {
      this.skip += 1;
    },
    handleNext() {
      if (!this.isAuthenticated) {
        EventBus.$emit('signIn');
        return;
      }

      if (!this.hasAccess) {
        this.showRequestAccess = true;
        return;
      }

      const result = this.$refs.current.next();

      if (result) {
        const { stage, data } = result;
        const nextStage = this.getNextStage(stage, data);

        this.stage = nextStage;

        switch (stage) {
          case 'TargetService':
            this.taskData.sandboxTargetServiceUrl = data.targetServiceUrl;
            break;
          case 'ProjectCode':
            this.taskData.projectName = data.projectName;
            this.taskData.javaPackage = data.fileSha;
            this.taskData.javaPackageName = data.fileName;
            this.taskData.lang = data.lang;
            break;
          case 'ServiceUrl': {
            if (!data.sameAsMainDomain) {
              this.taskData.sandboxTargetServiceUrl = data.serviceUrl;
            } else {
              this.taskData.sandboxTargetServiceUrl = this.taskData.sandboxHomePageUrl;
            }
            break;
          }
          case 'OptionalCode': {
            this.taskData.sourceCodeInfos = data.sourceCodeInfos;
            storage.remove('remoteBrowserUrl');
            this.loginInfos[this.loginInfoIndex].loginUrl = this.taskData.sandboxTargetServiceUrl;
            break;
          }
          case 'LoginUrl':
            this.taskData.sandboxHomePageUrl = data.sandboxHomePageUrl;
            this.loginInfos = this.loginInfos[this.loginInfoIndex]
              ? this.loginInfos.map((item, index) => {
                  if (index === this.loginInfoIndex) {
                    return {
                      ...item,
                      loginUrl: data.sandboxHomePageUrl,
                    };
                  }

                  return item;
                })
              : [...this.loginInfos, { loginUrl: data.sandboxHomePageUrl, testAccounts: [] }];
            this.skipAccount = data.skipAccount || false;
            break;
          case 'TestAccountConfirm':
            this.loginInfoIndex = data.confirm ? this.loginInfoIndex + 1 : this.loginInfoIndex;
            break;
          case 'TestAccount':
            this.taskData.testAccounts = data.accountList;
            this.loginInfos = this.loginInfos.map((item, index) => {
              if (index === this.loginInfoIndex) {
                return {
                  ...item,
                  testAccounts: data.accountList,
                  homePageUrl: data.homePageUrl,
                };
              }

              return item;
            });
            break;
          case 'LoginUrlBrowser':
            this.taskData.testAccounts = data.accounts;
            break;
        }

        if (['TargetService', 'ProjectCode', 'ServiceUrl', 'OptionalCode'].includes(stage)) {
          storage.set(ScanDataKey, { data: this.taskData, stage: nextStage, skipAccount: this.skipAccount }, expiration);
        }
      }
    },
    handlePrev() {
      const skipStage = ['TestAccountConfirm'];
      let prevStage = this.getPrevStage(this.stage);

      while (skipStage.includes(prevStage)) {
        prevStage = this.getPrevStage(prevStage);
      }

      const relatedData = StepStageMap.find((item) => item.stage.includes(this.stage))?.relatedData || [];

      if (prevStage) {
        const oldStage = this.stage;
        this.stage = prevStage;
        this.$nextTick(() => {
          relatedData
            .filter((item) => item.stage === oldStage)
            .forEach((item) => {
              this.taskData[item.key] = item.defaultValue;
            });
        });
        this.nextDisabled = false;
        this.nextLoading = false;

        if (oldStage === 'TestAccount') {
          this.loginInfos = this.loginInfos.map((item, index) => {
            if (index === this.loginInfoIndex) {
              return {
                ...item,
                testAccounts: [],
              };
            }

            return item;
          });
        }

        if (oldStage === 'LoginUrl') {
          this.loginInfos = this.loginInfos.filter((_, index) => index !== this.loginInfoIndex);
          this.loginInfoIndex = this.loginInfoIndex - 1 < 0 ? 0 : this.loginInfoIndex - 1;
        }
      }
    },
    handleSkip() {
      const nextStage = this.getNextStage(this.stage);

      this.stage = nextStage;
    },
    requestAccess() {
      this.$router.push({ name: 'Request' });
    },
    getSourceIp() {
      getSourceIp().then((res) => {
        if (res.ipv6) {
          this.sourceIp.ipv6 = res.ipv6;
        }
        if (res.ipv4) {
          this.sourceIp.ipv4 = res.ipv4;
        }
      });
    },
    getNextStage(currentStage, payload) {
      const currentStepIndex = StepStageMap.findIndex((item) => item.stage.includes(currentStage));
      const currentStep = StepStageMap[currentStepIndex];
      const currStageIndex = currentStep.stage.findIndex((item) => item === currentStage);

      if (currentStepIndex === StepStageMap.length - 1 && currStageIndex === currentStep.stage.length - 1) {
        return null;
      }

      if (currentStage === 'ServiceUrl' && payload?.sameAsMainDomain) {
        return StepStageMap[currentStepIndex + 1].stage[0];
      }

      if (currentStage === 'LoginUrl' && payload?.skipAccount) {
        return StepStageMap[currentStepIndex + 1].stage[0];
      }

      if (currentStage === 'TestAccountConfirm' && payload?.confirm) {
        return StepStageMap[currentStepIndex].stage[0];
      }

      if (currStageIndex === currentStep.stage.length - 1) {
        return StepStageMap[currentStepIndex + 1].stage[0];
      }

      return currentStep.stage[currStageIndex + 1];
    },
    getPrevStage(currentStage) {
      const currentStepIndex = StepStageMap.findIndex((item) => item.stage.includes(currentStage));
      const currentStep = StepStageMap[currentStepIndex];
      const currStageIndex = currentStep.stage.findIndex((item) => item === currentStage);

      if (currentStepIndex === 0 && currStageIndex === 0) {
        return null;
      }

      if (currentStage === 'LoginUrl') {
        if (this.loginInfoIndex > 0) {
          return currentStep.stage[currentStep.stage.length - 1];
        }
      }

      if (currStageIndex !== 0) {
        return currentStep.stage[currStageIndex - 1];
      }

      if (currentStage === 'TaskPreview' && this.skipAccount) {
        return StepStageMap[currentStepIndex - 1].stage[0];
      }

      return StepStageMap[currentStepIndex - 1].stage[StepStageMap[currentStepIndex - 1].stage.length - 1];
    },
    handleLoginUrlBrowserSkip() {
      const data = {
        accounts: [],
      };
      const nextStage = this.getNextStage('LoginUrlBrowser', data);
      this.stage = nextStage;
      this.taskData.testAccounts = data.accounts;
      this.skipAccount = true;
    },
    handleSubmit() {
      if (this.scanLoading) {
        return;
      }

      this.scanLoading = true;
      const homePageUrl = this.taskData.testAccounts?.[0]?.startUrl || '';

      let params = {
        projectName: this.taskData.projectName,
        lang: this.taskData.lang,
        sandboxTargetServiceUrl: this.taskData.sandboxTargetServiceUrl,
        sandboxHomePageUrl: homePageUrl || this.taskData.sandboxHomePageUrl || '',
        sourceCodeInfos: this.taskData.sourceCodeInfos,
        sandboxAuthInfos: this.taskData.testAccounts.map((accountInfo) => {
          return {
            roleName: accountInfo.role,
            loginUrl: accountInfo.startUrl,
            originRequestData: accountInfo.session,
          };
        }),
      };

      if (this.taskData.lang === LANGUAGE_TYPES.JAVA) {
        params = {
          ...params,
          javaPackage: this.taskData.javaPackage,
        };
      } else {
        params = {
          ...params,
          primarySourceCode: this.taskData.javaPackage,
        };
      }

      createTask(params)
        .then(() => {
          this.$router.push({ name: 'LoopholeScan' });
          storage.remove(ScanDataKey);
          storage.remove(RemoteBrowserUrlKey);
        })
        .finally(() => {
          this.scanLoading = false;
        });
    },
    handleDiscardDraft() {
      storage.remove(ScanDataKey);
      storage.remove(RemoteBrowserUrlKey);

      this.stage = StepStageMap[0].stage[0];
      const defaultData = getDefaultScanData();

      this.taskData.lang = defaultData.lang;
      this.taskData.projectName = defaultData.projectName;
      this.taskData.sandboxHomePageUrl = defaultData.sandboxHomePageUrl;
      this.taskData.sandboxTargetServiceUrl = defaultData.sandboxTargetServiceUrl;
      this.taskData.javaPackage = defaultData.javaPackage;
      this.taskData.javaPackageName = defaultData.javaPackageName;
      this.taskData.sourceCodeInfos = defaultData.sourceCodeInfos;
      this.taskData.testAccounts = defaultData.testAccounts;

      this.skipAccount = false;

      this.loginInfos = [
        {
          loginUrl: '',
          testAccounts: [],
        },
      ];

      this.handleCloseAlert();
    },
    handleCloseAlert() {
      this.isDraft = false;
    },
    countdown() {
      let count = this.countdownTime;

      const timer = setInterval(() => {
        count -= 1;
        this.countdownTime = count;

        if (count === 0) {
          clearInterval(timer);
          this.handleCloseAlert();
        }
      }, 1000);
    },
    toggleNextLoading(loading) {
      this.nextLoading = loading ?? !this.nextLoading;
    },
    toggleNextDisabled(disabled) {
      this.nextDisabled = disabled ?? !this.nextDisabled;
    },
    handleTermOfService() {
      this.dialogType = 'termsOfService';
      this.termOfServiceShow = true;
    },
    handlePrivacyPolicy() {
      this.dialogType = 'privacyPolicy';
      this.termOfServiceShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  background: linear-gradient(to bottom, #dfe9f3, #efefef);
  flex: 1;

  .content,
  .alertContent {
    max-width: 1440px;
  }

  .content {
    margin: 0 auto;
    padding-top: 40px;
    box-sizing: border-box;
    height: 100%;
  }

  @media screen and (max-width: 1920px) {
    .alertContent {
      width: 85%;
    }

    .content {
      width: 85%;
    }
  }

  @media screen and (max-width: 1440px) {
    .title {
      font-size: 20px;
    }

    .steps {
      min-width: 800px;
      margin-left: auto;
    }

    .alertContent {
      width: 95%;
    }

    .content {
      width: 95%;
    }

    .el-step__title {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 1280px) {
    .title {
      font-size: 14px;
    }

    .steps {
      min-width: 760px;
      margin-left: auto;
    }

    .container .label {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 1024px) {
    .title {
      font-size: 14px;
    }

    .steps {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    .title {
      font-size: 16px;
    }

    .steps {
      display: none;
    }
  }

  .scanBtnWrapper {
    padding: 10px 0;

    .nextButton {
      margin: 0;
      height: 100%;
    }
  }

  .accessDialog {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .accessDialogTitle {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .el-dialog {
    background: transparent;
    border-radius: 10px;
  }

  .custom-dialog-mark {
    .el-dialog__wrapper {
      position: relative;
    }

    .el-dialog__body {
      padding: 0 0;
    }

    .el-dialog__header {
      padding: 0px 0px 5px;
    }

    .el-dialog {
      background-color: black;
      color: #ffffff;
      border-radius: 4px;
      height: 180px;
    }

    .tooltip-arrow {
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid black;
      position: absolute;
      top: 100%;
      left: 10%;
      transform: translateX(-100%);
    }

    .tooltip-content {
      padding: 10px;
      text-align: left;
      color: #ffffff;
    }

    .tooltip-content h3 {
      margin: 0;
      padding: 0;
      font-size: 18px;
    }

    .dashed-line {
      border-bottom: 1px dashed white;
      margin: 10px 0;
    }
  }

  .custom-login-dialog {
    .el-dialog__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .el-dialog__header {
      padding: 0px 0px 0px;
    }

    .el-dialog {
      border-radius: 30px;
      padding: 20px;
      border: 2px solid #000000;
    }

    .el-dialog__body {
      padding: 0 0;
      border: 2px solid #333333;
      border-radius: 10px;
      background-color: #ffffff;
      height: 430px;
    }

    h3 {
      color: #000000;
    }

    .ed {
      display: flex;
      margin: 5px 35px;
      color: #333333;
      font-weight: bold;
      font-size: 12px;
    }

    .or-text {
      display: flex;
      align-items: center;
      text-align: center;
      color: #9e9a9a;
      margin: 15px 0;
    }

    .or-text::before,
    .or-text::after {
      content: '';
      flex: 1;
      border-bottom: 1px solid #dddddd;
      margin: 0 20px;
      width: 60px;
    }

    .el-input__inner {
      border: 1px solid #333333;
    }

    .login-content {
      text-align: center;
      margin-top: 15px;
    }

    .logo {
      width: 200px;
      height: 50px;
      // margin-bottom: 20px;
    }

    .oauth-button {
      width: 80%;
      height: 30px;
      margin: 10px 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      color: #333;
      border: 2px solid #333;
      border-radius: 10px;
      font-weight: bold;
    }

    .oauth-icon {
      width: 17px;
      margin: -4px 10px;
    }

    .oauth-button sapn {
      font-size: 14px;
    }

    .email-input {
      width: 80%;
    }

    .email-text {
      color: #000000;
      font-size: 17px;
      margin: 0px 30px;
    }

    .email-link-text {
      color: #908787;
    }

    .continue-button {
      width: 80%;
      height: 30px;
      line-height: 5px;
      background-color: #000000;
      border-radius: 5px;
      margin-top: 10px;
    }

    .email-continue-button {
      width: 80%;
      height: 30px;
      line-height: 5px;
      background-color: #000000;
      border-radius: 5px;
      margin-top: 30px;
    }

    .resend-link {
      color: #000000;
      cursor: pointer;
      text-decoration: underline;
    }

    .login-false-message {
      background-color: #f0f0f0;
      border: 1px solid #fff;
      border-radius: 10px;
      color: #565656;
      margin: 0 30px;
      height: 35px;
      line-height: 10px;
      width: 80%;
      font-size: 12px;
    }

    .login-false-row {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .sidebar {
    background-color: #ffffff;
    position: relative;
    margin: 0px 5px;
    border-radius: 10px;
  }

  .logo {
    text-align: center;
    padding: 10px 0;
  }

  .el-menu {
    text-align: center;
  }

  .el-menu-vertical-demo img {
    width: 20px;
    height: 20px;
    padding-right: 10px;
  }

  .sidebar-footer {
    position: absolute;
    bottom: 20px;
    left: 15px;
    text-align: center;
    display: flex;
    flex-direction: column;
    border-top: 1px solid #bbbbbb;
    width: 150px;
    margin: 0px 10px;
  }

  .sidebar-footer img {
    width: 30px;
    height: 30px;
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #ffffff;
    border-bottom: 1px solid #bbbbbb;
    margin: 0px 30px;
    height: 90px !important;
  }

  .header h2 {
    margin: 0;
  }

  .header p {
    margin: 0px 50px;
    font-size: 14px;
    color: #8e8e8e;
  }

  .el-container {
    background-color: #ffffff;
    margin: 0px 0px;
    border-radius: 10px;
    // height: calc(100vh - 20px);
  }

  .test-account {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    /* width: 95%; */
  }

  .test-account .el-select {
    width: 200px;
    padding-right: 10px;
  }

  .test-account .el-input__suffix {
    right: 10px;
  }

  .test-account .username {
    width: 200px;
  }

  .test-account .el-input {
    padding-right: 10px;
  }

  .el-main {
    padding: 20px;
  }

  .el-button {
    margin: 10px 0;
  }

  .custom-dialog .el-dialog__body {
    border-radius: 10px;
    padding: 20px;
  }

  .login-dialog {
    text-align: center;
  }

  .login-logo {
    width: 100px;
    margin-bottom: 20px;
  }

  .oauth-button {
    width: 100%;
    margin-top: 10px;
  }

  .underline {
    text-decoration: underline;
    text-decoration-color: #2b2b2b;
    position: relative;
    top: 10px;
    left: 50px;
  }

  .underline img {
    width: 20px;
    height: 20px;
    position: relative;
    top: 3px;
    right: 10px;
  }

  .underline .underImgFz {
    width: 20px;
    height: 20px;
    position: relative;
    right: 30px;
  }

  .underline .underImgView {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .underline .underView {
    padding-left: 10px;
  }

  .el-input .el-input__inner {
    height: 30px;
    line-height: 30px;
  }

  .project-ms {
    color: #8e8e8e;
    font-size: 14px;
    padding-left: 20px;
  }

  .scanNow {
    text-align: center;
    margin-top: 100px;
  }

  .scanNow button {
    background-color: #2b2b2b !important;
    color: #ffffff !important;
    border-radius: 10px !important;
    width: 30%;
    height: 50px;
  }

  .footer-item {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 20px;
  }

  .footer-item .logoImg {
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }

  .footer-item .userImg {
    width: 20px;
    height: 20px;
    margin-right: 40px;
  }

  .footer-item .userLogo {
    font-size: 14px;
    color: #2b2b2b;
  }

  .footer-item .userSpan {
    font-size: 14px;
    color: #2b2b2b;
    position: relative;
    right: 15px;
  }

  .error-message {
    display: flex;
    align-items: center;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    margin-top: 5px;
  }

  .warning-icon {
    width: 15px;
    height: 10px;
    background-color: #ffcb00;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    position: relative;
    margin: 5px 5px;
  }

  .warning-icon::before {
    content: '!';
    color: #333333;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: bold;
    font-size: 10px;
  }

  .error-text {
    color: #ff0000;
    position: relative;
    top: 2px;
  }

  .request-access {
    color: #333333;
    cursor: pointer;
    margin-left: 10px;
    text-decoration: underline;
    position: relative;
    top: 2px;
  }
}

.alertContent {
  width: 80%;
  margin: auto;
}

.content {
  width: 80%;
  margin: 40px auto 0;
}

.footer {
  position: relative;
  display: flex;
  justify-content: center;
}

.nextButton {
  width: 400px;
  font-size: 24px;
  font-weight: bold;
  padding: 0;
}

#signInContainer {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.steps {
  min-width: 1000px;
  margin-left: 100px;
}

.footerBtn {
  display: flex;
  justify-content: center;
  width: 800px;
}

.primaryButton {
  &:not(:first-child) {
    margin-left: 20px;
  }
}

.main {
  position: relative;
}
</style>
<style lang="scss">
.stepTitle {
  text-align: right;
}

.termOfServiceDialog {
  .el-dialog__body {
    padding: 0 0 30px !important;
  }
}

.termOfService {
  position: relative;
  height: 65vh;
  margin-bottom: 30px;
  word-break: break-word;
}

.termOfServiceContent {
  height: 100%;
  overflow: auto;
  padding: 0 30px;
}

.termOfServiceBtn {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
}

.checkService {
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 500;

  .checkboxService {
    .el-checkbox__inner {
      width: 16px;
      height: 16px;
      border-color: #333333;

      &::after {
        height: 9px;
        left: 5px;
      }
    }
  }

  .checkServiceText {
    margin-left: 16px;
    font-size: 18px;
    color: #212121;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #67c23a;
    border-color: #67c23a;
  }

  .el-checkbox__inner:hover {
    border-color: #67c23a;
  }

  .serviceItem {
    cursor: pointer;
    text-decoration: underline;
  }
}
.main-container {
  @media screen and (max-width: 1440px) {
    .el-step__title {
      font-size: 14px;
    }
  }
}
</style>